import {
  BookingAreaEditor,
  CoveragePreviewCard,
  type CoveragePreviewDraft,
} from '@/components/operator/booking-area-editor'
import type { OperatorConfigurationState } from '@/lib/operator-config/types'

export function ServiceFootprintEditor({
  configuration,
  onSaved,
  onRegisterSubmit,
  onboardingMode = false,
  onPreviewChange,
}: {
  configuration: OperatorConfigurationState
  onSaved?: () => Promise<void> | void
  onRegisterSubmit?: (submit: () => Promise<boolean>) => void
  onboardingMode?: boolean
  onPreviewChange?: (draft: CoveragePreviewDraft | null) => void
}) {
  return (
    <BookingAreaEditor
      configuration={configuration}
      onSaved={onSaved}
      singleAreaOnly
      hidePrimarySubmit
      onboardingMode={onboardingMode}
      showInlinePreview={!onboardingMode}
      onRegisterSubmit={onRegisterSubmit}
      onPreviewChange={onPreviewChange}
    />
  )
}

export { CoveragePreviewCard }
export type { CoveragePreviewDraft }
